import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "../App.css";
const Navbar = () => {
  return (
    <div>
      <nav className="navbar nav-bg-image">
        <img
          src="https://media0.giphy.com/media/kGVrfTTgBfQpLGuAcS/giphy.gif"
          width="200"
          height="80"
          alt="stars"
        />
        <img
          src="https://media0.giphy.com/media/kGVrfTTgBfQpLGuAcS/giphy.gif"
          width="200"
          height="80"
          alt="stars"
        />
        
      </nav>
    </div>
  );
};


export default Navbar;
